// Hydronate BP/Cholesterol PDP — interactions
// - Tier selection (3 buy-box tiers)
// - Add to cart (subscription-only, force selling plan)
// - Image gallery
// - Accordion toggles (FAQ, How It Works, Quickproof)
// - Smooth scroll to buy-box
// - Sticky cart price sync
(function () {
  'use strict';
  if (window.__BP_PDP_INIT__) return;
  window.__BP_PDP_INIT__ = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  function init() {
    if (window.__BP_PDP_BOUND__) return;
    window.__BP_PDP_BOUND__ = true;
    bindTiers();
    bindGallery();
    bindAccordions();
    bindScrollAnchors();
    bindSubToggle();
    bindAddToCart();
    bindHeaderRedirect();
    bindCartDrawerLinks();
    bindOfferCards();
    bindUtilityBarTop();
    bindFooterLogo();
  }

  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }

  // ── Tier selection ──────────────────────────────────────────────
  function bindTiers() {
    const tiers = $$('[data-bp-tier]');
    if (!tiers.length) return;

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        const id = t.getAttribute('data-bp-tier');
        selectTier(id);
      });
    });

    // Pre-select default tier (data-bp-default on one of them)
    const defaultTier = $('[data-bp-tier][data-bp-default="true"]') || tiers[0];
    if (defaultTier) selectTier(defaultTier.getAttribute('data-bp-tier'));
  }

  function selectTier(id) {
    $$('[data-bp-tier]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-bp-tier') === id);
    });
    const active = $('[data-bp-tier][data-bp-tier="' + id + '"]');
    if (!active) return;

    const variantId = active.getAttribute('data-bp-variant-id');
    const label = active.getAttribute('data-bp-label') || '';

    // Update hidden form input
    const idInput = $('#bp-pdp-form input[name="id"]');
    if (idInput) idInput.value = variantId;

    // Sticky cart label sync — skip on infl-pdp-cold and hyd-002-chol-cold-lp-v4-cart so the static section name stands.
    const stickyLabel = $('[data-bp-sticky-label]');
    if (stickyLabel && label && !document.body.classList.contains('infl-pdp-cold') && !document.body.classList.contains('hyd-002-chol-cold-lp-v4-cart')) stickyLabel.textContent = 'Hydronate · ' + label;

    // Recompute displayed prices + per-day microcopy (toggle-aware)
    refreshPrices();
  }

  function getCurrentTierPrice() {
    const active = $('[data-bp-tier].is-active');
    if (!active) return 0;
    return parseFloat(active.getAttribute('data-bp-price') || '0');
  }

  function refreshPrices() {
    const toggle = $('[data-bp-sub-toggle]');
    const isSubbed = toggle ? toggle.checked : true;
    const wrap = $('.sub-toggle');
    if (wrap) wrap.classList.toggle('is-checked', isSubbed);
    const pct = parseFloat((wrap && wrap.getAttribute('data-bp-sub-pct')) || '20');
    const factor = isSubbed ? (1 - pct / 100) : 1;

    // Update each tier card's displayed price (the "now" price line) AND
    // recompute its "$X.XX/tablet" sub line based on tablet count.
    $$('[data-bp-tier]').forEach(function (tier) {
      const tierPrice = parseFloat(tier.getAttribute('data-bp-price') || '0');
      const tablets = parseFloat(tier.getAttribute('data-bp-tablets') || '0');
      const shown = +(tierPrice * factor).toFixed(2);
      const priceEl = tier.querySelector('.tier-price-now');
      if (priceEl) priceEl.textContent = '$' + shown.toFixed(2);

      if (tablets > 0) {
        const perTablet = (shown / tablets).toFixed(2);
        const subEl = tier.querySelector('.tier-sub');
        if (subEl) {
          // Cache original text once so we always rebuild from the same source.
          if (!subEl.hasAttribute('data-bp-sub-orig')) {
            subEl.setAttribute('data-bp-sub-orig', subEl.textContent);
          }
          const orig = subEl.getAttribute('data-bp-sub-orig');
          subEl.textContent = orig.replace(/\$\d+\.\d+\s*\/\s*tablet/, '$' + perTablet + '/tablet');
        }
      }
    });

    // ATC button price uses the active tier.
    const activeTier = getCurrentTierPrice();
    const activeShown = +(activeTier * factor).toFixed(2);
    $$('[data-bp-cta-price]').forEach(function (el) {
      el.textContent = '$' + activeShown.toFixed(2);
    });

    // Per-day microcopy ("Buy More, Save More" header right side) — uses the
    // active tier and changes wording when subscribed.
    const activeEl = $('[data-bp-tier].is-active');
    const perDayEl = $('[data-bp-per-day]');
    if (activeEl && perDayEl) {
      if (isSubbed) {
        const subLine = activeEl.getAttribute('data-bp-per-day-compare-sub') || '';
        perDayEl.textContent = subLine;
      } else {
        const perDay = activeEl.getAttribute('data-bp-per-day') || '';
        const perDayCompare = activeEl.getAttribute('data-bp-per-day-compare') || '';
        perDayEl.textContent = perDay ? '$' + perDay + '/day · ' + perDayCompare : '';
      }
    }

    // Sub-toggle "price" always shows the subscribed price for the active tier.
    const subPrice = +(activeTier * (1 - pct / 100)).toFixed(2);
    const subPriceEl = $('[data-bp-sub-price]');
    if (subPriceEl) subPriceEl.textContent = '$' + subPrice.toFixed(2);

    // Swap any guarantee text that depends on subscribe state.
    $$('[data-bp-guarantee-swap]').forEach(function (g) {
      const label = g.querySelector('[data-bp-guarantee-label]');
      if (!label) return;
      const subText = g.getAttribute('data-sub-text') || '';
      const otpText = g.getAttribute('data-otp-text') || '';
      label.textContent = isSubbed ? subText : otpText;
    });
  }

  // ── Image gallery (swipe carousel + dots + desktop thumbs) ──────
  function bindGallery() {
    $$('.hero-gallery').forEach(function (gallery) {
      const stage = $('[data-bp-stage]', gallery);
      if (!stage) return;
      const slides = $$('[data-bp-slide]', stage);
      const dots = $$('[data-bp-dot]', gallery);
      const thumbs = $$('[data-bp-thumb]', gallery);
      if (!slides.length) return;

      function scrollTo(idx) {
        const target = slides[idx];
        if (!target) return;
        stage.scrollTo({ left: target.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      }

      function setActive(idx) {
        dots.forEach(function (d) {
          d.classList.toggle('is-active', parseInt(d.getAttribute('data-bp-dot'), 10) === idx);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.getAttribute('data-bp-thumb'), 10) === idx);
        });
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          scrollTo(parseInt(d.getAttribute('data-bp-dot'), 10));
        });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          scrollTo(parseInt(t.getAttribute('data-bp-thumb'), 10));
        });
      });

      let scrollTimer;
      stage.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          const idx = Math.round(stage.scrollLeft / stage.clientWidth);
          setActive(idx);
        }, 60);
      });
    });
  }

  // ── Accordion (FAQ, How It Works, Quickproof) ──────────────────
  function bindAccordions() {
    $$('[data-bp-accordion]').forEach(function (group) {
      const items = $$('[data-bp-accordion-item]', group);
      items.forEach(function (item) {
        const trigger = $('[data-bp-accordion-trigger]', item);
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          const wasOpen = item.classList.contains('is-open');
          // Optional: collapse siblings within the group
          if (group.getAttribute('data-bp-accordion') === 'single') {
            items.forEach(function (x) { x.classList.remove('is-open'); });
          }
          item.classList.toggle('is-open', !wasOpen);
          updateAccordionIcon(item);
        });
        updateAccordionIcon(item);
      });
    });
  }

  function updateAccordionIcon(item) {
    const ico = $('[data-bp-accordion-icon]', item);
    if (!ico) return;
    ico.textContent = item.classList.contains('is-open') ? '−' : '+';
  }

  // ── Smooth scroll anchors ──────────────────────────────────────
  function bindScrollAnchors() {
    $$('[data-bp-scroll-to]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        const targetSel = link.getAttribute('data-bp-scroll-to');
        const target = document.querySelector(targetSel);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Also flip to 3mo tier on final CTA
          if (link.hasAttribute('data-bp-select-tier')) {
            selectTier(link.getAttribute('data-bp-select-tier'));
          }
        }
      });
    });
  }

  // ── Header logo + menu redirect (this-page only) ────────────────
  // Rewrites the theme header's logo link and intercepts the mobile menu
  // toggle so both behaviors send the user back to /pages/bp-pdp instead
  // of going to the homepage / opening the menu drawer.
  function bindHeaderRedirect() {
    const target = window.location.pathname;
    const headerScope = document.querySelectorAll(
      '.shopify-section-header, .shopify-section-group-header-group, header, .site-header'
    );
    if (!headerScope.length) return;

    headerScope.forEach(function (scope) {
      // Rewrite anchors pointing at the homepage root
      scope.querySelectorAll('a[href]').forEach(function (a) {
        const href = a.getAttribute('href');
        if (href === '/' || href === window.location.origin + '/' || href === window.location.origin) {
          a.setAttribute('href', target);
        }
      });

      // Hide menu-toggle elements entirely (this-page only)
      const triggers = scope.querySelectorAll(
        '.mobile-nav-trigger, .menu-trigger, .site-header__menu-toggle, [data-mobile-nav-trigger], button[aria-controls*="menu" i], button[aria-controls*="nav" i], button[aria-label*="menu" i], .js-mobile-nav-toggle, .header__icon--menu'
      );
      triggers.forEach(function (el) { el.style.display = 'none'; });

      // Hide any button/link with literal "MENU" text (case-insensitive)
      scope.querySelectorAll('button, a').forEach(function (el) {
        const txt = (el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
        if (txt === 'MENU' || txt === '☰ MENU' || txt === '≡ MENU') {
          el.style.display = 'none';
        }
      });
    });
  }

  // ── Footer logo: link back to this same page ────────────────────
  // The theme footer logo is a bare <img> (no link). On these LPs we keep
  // traffic on-page, so wrap it in a link to the CURRENT page rather than
  // letting it go nowhere / to the homepage. This script only loads on the
  // LP templates, so the global/homepage footer is untouched.
  function bindFooterLogo() {
    const img = document.querySelector('.site-footer .logo_wrap img, .footer_top_content .logo_wrap img');
    if (!img) return;
    const here = window.location.pathname;
    const existing = img.closest('a');
    if (existing) { existing.setAttribute('href', here); return; }
    const a = document.createElement('a');
    a.href = here;
    a.setAttribute('aria-label', 'Hydronate');
    a.style.display = 'inline-block';
    img.parentNode.insertBefore(a, img);
    a.appendChild(img);
  }

  // ── Utility bar: move DOM-wise above the theme header ──────────
  // Page sections render inside <main>, which is below the header section
  // group. This moves the .bp-utility wrapper to be the very first child of
  // <body> so it sits above the header bar — matching the brief mockup.
  function bindUtilityBarTop() {
    const utility = document.querySelector('.bp-utility');
    if (!utility) return;
    const wrapper = utility.closest('.shopify-section');
    if (!wrapper) return;
    const target =
      document.querySelector('.shopify-section-announcement-bar') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('.shopify-section-header');
    if (!target || !target.parentNode) return;
    // Already in position?
    if (wrapper.nextElementSibling === target) return;
    target.parentNode.insertBefore(wrapper, target);
  }

  // ── Offer cards (3-card grid, cold LP variant) ──────────────────
  // Each card POSTs its own variant + the shared selling_plan to /cart/add.
  // The Subscribe & Save toggle above the grid controls whether selling_plan
  // is included in the cart submission AND triggers live price updates.
  function bindOfferCards() {
    const grid = document.querySelector('[data-bp-offer-cards]');
    if (!grid) return;
    const sellingPlan = grid.getAttribute('data-bp-offer-plan') || '';
    const offerToggle = document.querySelector('[data-bp-offer-sub-toggle]');
    const subPct = parseFloat(grid.getAttribute('data-bp-offer-sub-pct') || '20');

    function isSubbed() {
      if (!offerToggle) return true;
      return offerToggle.checked;
    }

    function refreshOfferPrices() {
      const subbed = isSubbed();
      const wrap = offerToggle ? offerToggle.closest('.bp-offer-toggle') : null;
      if (wrap) wrap.classList.toggle('is-checked', subbed);
      // Inverse factor: stored prices ARE the subscribed prices. When toggle
      // turns OFF, the one-time price = sub / (1 - pct/100) = sub * (1/0.8).
      const otpFactor = 1 / (1 - subPct / 100);
      grid.querySelectorAll('.bp-offer-card').forEach(function (card) {
        const sub = parseFloat(card.getAttribute('data-bp-card-price-sub') || '0');
        const strikeSub = card.getAttribute('data-bp-card-strike-sub') || '';
        const priceEl = card.querySelector('[data-bp-card-price-display]');
        const strikeEl = card.querySelector('[data-bp-card-strike-display]');
        if (sub && priceEl) {
          const shown = subbed ? sub : +(sub * otpFactor).toFixed(2);
          priceEl.textContent = '$' + shown.toFixed(2);
        }
        // Strike stays as the original strike price regardless — it's the
        // "compare-at" reference, not the sub vs. OTP delta.
        if (strikeEl && strikeSub) strikeEl.textContent = '$' + strikeSub;
      });
    }

    if (offerToggle) {
      offerToggle.addEventListener('change', refreshOfferPrices);
      refreshOfferPrices();
    }

    grid.querySelectorAll('[data-bp-offer-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const variantId = btn.getAttribute('data-bp-card-variant');
        if (!variantId) return;
        const origLabel = btn.querySelector('[data-bp-card-cta-label]');
        const prevText = origLabel ? origLabel.textContent : '';
        btn.setAttribute('disabled', '');
        if (origLabel) origLabel.textContent = 'Adding…';
        const item = { id: parseInt(variantId, 10), quantity: 1 };
        if (sellingPlan && isSubbed()) item.selling_plan = parseInt(sellingPlan, 10);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        .then(function (r) { return r.ok ? r.json() : r.text().then(function (t) { throw new Error(t || r.statusText); }); })
        .then(function () {
          const sidebar = document.getElementById('sidebar-cart');
          if (document.body.classList) document.body.classList.add('show_overlay');
          if (sidebar) sidebar.classList.add('show');
          fetch('/cart?view=drawer').then(function (r) { return r.text(); }).then(function (html) {
            if (!sidebar) { window.location.href = '/cart'; return; }
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newCart = doc.querySelector('.Cart');
            const oldCart = sidebar.querySelector('.Cart');
            if (newCart && oldCart) oldCart.replaceWith(newCart);
          }).catch(function () { window.location.href = '/cart'; });
        })
        .catch(function (err) {
          console.error('[bp-pdp] offer-card add failed', err);
          alert('Sorry, something went wrong adding to cart. Please try again.');
        })
        .finally(function () {
          btn.removeAttribute('disabled');
          if (origLabel) origLabel.textContent = prevText;
        });
      });
    });
  }

  // ── Cart drawer product links redirect to bp-pdp ────────────────
  // Uses event delegation on document.body so it catches links inside the
  // cart drawer even though that markup is rendered dynamically after add.
  function bindCartDrawerLinks() {
    const target = window.location.pathname;
    document.body.addEventListener('click', function (e) {
      const link = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!link) return;
      const inCart = link.closest('#sidebar-cart, .Cart, .cart, [data-cart-drawer], #CartDrawer');
      if (!inCart) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = target;
    }, true);
  }

  // ── Subscribe & Save toggle ─────────────────────────────────────
  function bindSubToggle() {
    const toggle = $('[data-bp-sub-toggle]');
    if (!toggle) return;
    toggle.addEventListener('change', function () {
      refreshPrices();
    });
    refreshPrices();
  }

  // ── Add to cart (toggle controls selling_plan inclusion) ────────
  function bindAddToCart() {
    const form = document.getElementById('bp-pdp-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const cta = $('[data-bp-cta]', form) || form.querySelector('button[type=submit]');
      const variantId = (form.querySelector('input[name=id]') || {}).value;
      const sellingPlanInput = form.querySelector('input[name=selling_plan]');
      const sellingPlan = sellingPlanInput ? sellingPlanInput.getAttribute('data-bp-selling-plan') : null;
      const subToggle = $('[data-bp-sub-toggle]');
      const isSubbed = subToggle ? subToggle.checked : true;
      if (!variantId) {
        console.warn('[bp-pdp] No variant selected');
        return;
      }
      const item = { id: parseInt(variantId, 10), quantity: 1 };
      if (isSubbed && sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
      item.properties = { _lp_url: window.location.pathname + window.location.search };
      const payload = { items: [item] };
      if (cta) { cta.setAttribute('disabled', ''); cta.dataset.prevLabel = cta.textContent; cta.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (r) { return r.ok ? r.json() : r.text().then(function (t) { throw new Error(t || r.statusText); }); })
      .then(function () {
        // Try opening the existing theme's cart drawer (Arcady/Impulse-family selector)
        const drawerOpener =
          document.querySelector('[data-cart-trigger]') ||
          document.querySelector('a[href="/cart"]') ||
          document.querySelector('.Header__CartCount, .header__icon--cart');
        if (window.theme && typeof window.theme.cart === 'object' && typeof window.theme.cart.refresh === 'function') {
          window.theme.cart.refresh();
        }
        if (document.body.classList) {
          document.body.classList.add('show_overlay');
        }
        const sidebar = document.getElementById('sidebar-cart');
        if (sidebar) sidebar.classList.add('show');
        // Refresh drawer via section render API
        fetch('/cart?view=drawer').then(function (r) { return r.text(); }).then(function (html) {
          if (!sidebar) {
            // Fallback: go to /cart
            window.location.href = '/cart';
            return;
          }
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCart = doc.querySelector('.Cart');
          const oldCart = sidebar.querySelector('.Cart');
          if (newCart && oldCart) oldCart.replaceWith(newCart);
        }).catch(function () { window.location.href = '/cart'; });
      })
      .catch(function (err) {
        console.error('[bp-pdp] add to cart failed', err);
        alert('Sorry, something went wrong adding to cart. Please try again.');
      })
      .finally(function () {
        if (cta) { cta.removeAttribute('disabled'); if (cta.dataset.prevLabel) cta.textContent = cta.dataset.prevLabel; }
      });
    });
  }
})();

